import { useFetchImageUploaderImageList } from '@api';
import { PathnameEnum } from '@constant';
import { useState } from 'react';
import { useNavigate } from 'react-router';

//이미지 업로더 - 이미지 리스트 페이지 로직에 관여
export const useImageUploaderImageList = () => {
  //이미지 리스트 페이지 관련
  const [page, setPage] = useState<number>(1);

  const navigate = useNavigate();

  const tableHeader = [
    { id: 'id', label: 'ID', width: 74 },
    { id: 'sequenceId', label: '시퀀스 ID', width: 82 },
    { id: 'fileName', label: '파일명', width: 452 },
    { id: 'sexualPosition', label: '체위', width: 100 },
    { id: 'femaleBody', label: '여체', width: 100 },
    { id: 'sexualBodyPart', label: '신체 부위', width: 200 },
    { id: 'characterNumber', label: '인원수', width: 120 },
    { id: 'frame', label: '프레임', width: 100 },
    { id: 'angleFirst', label: '가로앵글', width: 80 },
    { id: 'angleSecond', label: '세로앵글', width: 80 },
    { id: 'metaTags', label: '관련 태그', width: 452 }
  ];

  const { response } = useFetchImageUploaderImageList(page);

  const handleImageUploadButtonClick = () => {
    navigate(PathnameEnum.IMAGE_UPLOADER_ADULTS_ONLY_IMAGE_UPLOAD_PAGE);
  };

  const handleTableRowClick = (imageId: number, sequenceId?: number) => {
    navigate(
      `${PathnameEnum.IMAGE_UPLOADER_ADULTS_ONLY_IMAGE_EDIT_PAGE.replace(':imageIdParam', String(imageId))}${sequenceId ? `?sequenceId=${sequenceId}` : ''}`
    );
  };

  return {
    handleImageUploadButtonClick,
    handleTableRowClick,

    tableHeader,
    response,
    page,
    setPage
  };
};
